// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1K1Zk","vLegacy":"SelectSecondary_vLegacy__3FcmB","error":"SelectSecondary_error__19C-N","disabled":"SelectSecondary_disabled__1uZrv"};